import React from "react";

export const INDIAN_LANGUAGES = [
    { code: "ta", name: "Tamil" },
    { code: "hi", name: "Hindi" },
    { code: "ml", name: "Malayalam" },
    { code: "te", name: "Telugu" },
    { code: "kn", name: "Kannada" },
    { code: "bn", name: "Bengali" },
    { code: "mr", name: "Marathi" },
    { code: "gu", name: "Gujarati" },
    { code: "pa", name: "Punjabi" },
    { code: "or", name: "Odia" },
    { code: "ur", name: "Urdu" },
    { code: "sa", name: "Sanskrit" },
    { code: "as", name: "Assamese" },
    { code: "ne", name: "Nepali" },
];

// Credit cost constants
export const BASE_CREDITS = { audio: 100, video: 200, youtube: 200, ppt: 100, pdf: 100, word: 100 };
export const FORMAT_CREDITS = { paragraph: 100, qna: 150, mcq: 200 };
export const TRANSLATE_CREDITS = 50;

export function calcCredits(mediaType, format, translateTo, numQuestions = 0) {
    const base = BASE_CREDITS[mediaType] || 100;
    let fmt = FORMAT_CREDITS[format] || 100;

    // MCQ Surcharge: 1 credit per question if total > 100
    if (format === 'mcq' && numQuestions > 100) {
        fmt += (numQuestions - 100);
    }

    const trans = translateTo ? TRANSLATE_CREDITS : 0;
    return base + fmt + trans;
}

export default function TranslateDropdown({ value, onChange }) {
    // Temporarily hide translation selection as requested for more testing
    return null;

    return (
        <div style={{ marginBottom: "20px" }}>
            <label htmlFor="translate-select" style={{ display: "block", marginBottom: "8px", fontWeight: "600" }}>
                🌐 Translate To:
            </label>
            <select
                id="translate-select"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "8px",
                    border: "1px solid rgba(255,255,255,0.2)",
                    backgroundColor: "rgba(255,255,255,0.1)",
                    color: "inherit",
                    cursor: "pointer",
                    fontSize: "0.95rem",
                }}
            >
                <option value="">English (Default)</option>
                {INDIAN_LANGUAGES.map((lang) => (
                    <option key={lang.code} value={lang.name}>
                        {lang.name}
                    </option>
                ))}
            </select>
            {value && (
                <p style={{ fontSize: "0.8em", color: "orange", marginTop: "5px" }}>
                    ⚠️ Translation costs an extra 50 credits.
                </p>
            )}
        </div>
    );
}
